<template>
  <v-container class="widget-dashboard-icons">
    <dash-header
      :date-range="$route.params.dateRange"
      :enable-date-selector="false"
      v-on:date-range-changed="triggerUpdates"
      v-on:range-config-updated="triggerUpdates"
      class="mb-5"
    ></dash-header>

    <v-layout align-start justify-center row>
      <v-card class="widget-report__widget mr-5">
        <v-card-text>
          <a href="/#/dashboard/conversion-py"><img src="../../assets/images/landing-conversions-with.png" /></a>
        </v-card-text>
      </v-card>
      <v-card class="widget-report__widget mr-5">
        <v-card-text>
          <a href="/#/dashboard/conversion"><img src="../../assets/images/landing-conversions-without.png" /></a>
        </v-card-text>
      </v-card>
      <v-card class="widget-report__widget">
        <v-card-text>
          <a href="/#/dashboard/escalation"><img src="../../assets/images/landing-escalations.png" /></a>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import DashHeader from "../../elements/DashHeader";
import ConversionGauge from "../conversion/widgets/ConversionGauge";
import FulfillmentGauge from "../fulfillment/widgets/FulfillmentGauge";
import Vue from "vue";
import moment from "moment";

export default {
  name: "LandingSection",
  components: {DashHeader, ConversionGauge, FulfillmentGauge},
  data() {
    return {
      bus: new Vue()
    }
  },
  methods: {
    triggerUpdates() {
      this.bus.$emit('update-data');
    }
  }
}
</script>

<style>
  .widget-report__widget tbody {
    min-height: 0;
  }
</style>
